<template md-elevation="0">
    <div id="layout-config" :class="containerClass" style="margin-top:5rem;">
        <a href="#" class="layout-config-button" id="layout-config-button" @click="toggleConfigurator">
            <md-icon style="color:white;">settings</md-icon>
        </a>
        <a class="layout-config-close" @click="hideConfigurator" :style="{ 'z-index': 1 }"><md-icon>close</md-icon></a>

        <div class="layout-config-content">
            <h3 class="mt-0 title">Escala</h3>
            <div class="config-scale">
                <md-button style="background:#212121!important; margin: 0 1rem 0 1rem;" @click="decrementScale()" class="p-button-text" :disabled="scale === scales[0]"><md-icon>remove</md-icon></md-button>
                <!-- <md-icon style="transform:scale(0.6);margin:0rem;" v-for="s of scales" :class="{ 'scale-active': s === scale }" :key="s">circle</md-icon> -->
                <md-button style="background:#212121!important;" @click="incrementScale()" class="p-button-text" :disabled="scale === scales[scales.length - 1]"><md-icon>add</md-icon></md-button>
            </div>

            <h3 class="mt-0 title">Temas</h3>
            <div class="grid">
                <div class="col-12 ">
                    <div class="field mb-0 text-center">
                        <md-radio id="light" value="light" v-model="radio" @change="theme()" />
                        <label for="light">Claro </label>

                        <md-radio id="dark" value="dark" v-model="radio" @change="theme()" style="margin-left:1rem" />
                        <label for="dark">Oscuro</label>
                    </div>
                </div>

                <h3 class="mt-5 title">Filtros</h3>
                <div class="grid free-themes">
                    <div class="col-3 text-center">
                        <md-button id="filter1" class="p-link p-button-text active" type="button" @click="filter1()"
                            >Monocroma
                            <md-icon style="color:white;">palette</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="grid free-themes">
                    <div class="col-3 text-center">
                        <md-button id="filter2" class="p-link p-button-text" type="button" @click="filter2()"
                            >Alto contraste
                            <md-icon style="color:white;">contrast</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="grid free-themes">
                    <div class="col-3 text-center">
                        <md-button id="filter3" class="p-link p-button-text" type="button" @click="filter3()">
                            Negro sobre blanco
                            <md-icon style="color:white;">featured_video</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="grid free-themes">
                    <div class="col-3 text-center">
                        <md-button id="filter4" class="p-link p-button-text" type="button" @click="filter4()">
                            Blanco sobre negro
                            <md-icon style="color:white">note</md-icon>
                        </md-button>
                    </div>
                </div>
                <div class="grid free-themes">
                    <div class="col-3 text-center">
                        <md-button id="reset" class="p-link" type="button" @click="resetfilters()">Reset</md-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        layoutMode: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            active: false,
            d_layoutMode: this.layoutMode,
            scale: 20,
            scales: [16, 17, 18, 19, 20, 21, 22, 23, 24],
            radio: "light"
        };
    },

    watch: {
        $route() {
            if (this.active) {
                this.active = false;
                this.unbindOutsideClickListener();
            }
        },
        layoutMode(newValue) {
            this.d_layoutMode = newValue;
        }
    },
    outsideClickListener: null,
    methods: {
        toggleConfigurator(event) {
            this.active = !this.active;
            event.preventDefault();

            if (this.active) this.bindOutsideClickListener();
            else this.unbindOutsideClickListener();
        },
        hideConfigurator(event) {
            this.active = false;
            this.unbindOutsideClickListener();
            event.preventDefault();
        },

        bindOutsideClickListener() {
            if (!this.outsideClickListener) {
                this.outsideClickListener = (event) => {
                    if (this.active && this.isOutsideClicked(event)) {
                        this.active = false;
                    }
                };
                document.addEventListener("click", this.outsideClickListener);
            }
        },
        unbindOutsideClickListener() {
            if (this.outsideClickListener) {
                document.removeEventListener("click", this.outsideClickListener);
                this.outsideClickListener = null;
            }
        },
        isOutsideClicked(event) {
            return !(this.$el.isSameNode(event.target) || this.$el.contains(event.target));
        },
        decrementScale() {
            this.scale--;
            this.applyScale();
        },
        incrementScale() {
            this.scale++;
            this.applyScale();
        },
        applyScale() {
            document.documentElement.style.fontSize = this.scale + "px";
        },

        filter1() {
            this.resetfilters();
            document.documentElement.style.filter = "grayscale(100%)";
            document.getElementById("filter1").classList.add("activebutton");
            document.getElementById("reset").classList.add("reset");
        },
        filter2() {
            this.resetfilters();
            document.documentElement.style.filter = "invert(100%)";
            document.getElementById("filter2").classList.add("activebutton");
            document.getElementById("reset").classList.add("reset");
        },
        filter3() {
            this.resetfilters();

            if (this.radio == "dark") {
                document.getElementById("reset").classList.add("reset");
            } else {
                document.getElementById("filter3").classList.add("activebutton");
                document.getElementById("reset").classList.add("reset");
            }
            document.documentElement.style.filter = "brightness(70%) contrast(300%) saturate(0%)";
        },
        filter4() {
            this.resetfilters();

            document.documentElement.style.filter = "brightness(70%)  contrast(300%) saturate(0%) invert(100%)";
            if (this.radio == "dark") {
                document.getElementById("reset").classList.add("reset");
            } else {
                document.getElementById("reset").classList.add("reset");
                document.getElementById("filter4").classList.add("activebutton");
            }
        },
        resetfilters() {
            document.documentElement.style.filter = "none";
            document.getElementById("filter1").classList.remove("activebutton");
            document.getElementById("filter2").classList.remove("activebutton");
            document.getElementById("filter3").classList.remove("activebutton");
            document.getElementById("filter4").classList.remove("activebutton");
            document.getElementById("reset").classList.remove("reset");
        },

        theme() {
            //console.log(this.radio);
            if (this.radio == "dark") {
                // document.getElementById("toolbar").classList.remove("md-white");
                // document.getElementById("toolbar").classList.add("md-dark");

                // document.getElementById("toolbar").style.background = "black!important";
                // document.getElementById("toolbar").style.color = "white";
                document.getElementById("footer").style.background = "black";
                document.getElementById("footer").style.color = "white";

                document.getElementById("toolbar").style.filter = "invert(100%)";
                document.getElementById("layout-config").style.filter = "invert(100%)";
                //document.getElementById("footer").style.filter = "invert(100%)";
            } else {
                // document.getElementById("toolbar").classList.remove("md-dark");
                // document.getElementById("toolbar").classList.add("md-white");
                // document.getElementById("toolbar").style.color = "#3C4858";
                //document.getElementById("layout-config").style.background = "white";

                document.getElementById("footer").style.background = "white";
                document.getElementById("footer").style.color = "black";

                document.getElementById("layout-config").style.filter = "invert(0%)";
                document.getElementById("toolbar").style.filter = "invert(0%)";
                //document.getElementById("footer").style.filter = "invert(0%)";
            }
        }
    },
    computed: {
        containerClass() {
            return ["layout-config", { "layout-config-active": this.active }];
        },
        rippleActive() {
            return this.$primevue.config.ripple;
        },
        inputStyle() {
            return this.$appState.inputStyle;
        }
    }
};
</script>
